import { render, staticRenderFns } from "./ReferencesWidget.vue?vue&type=template&id=72a5a68a&"
import script from "./ReferencesWidget.vue?vue&type=script&lang=js&"
export * from "./ReferencesWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports